// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"wF","blender_bottle_img":"xF","blender_bottle_info":"yF","blender_bottle_title":"zF","blender_bottle_bold":"AF","blender_bottle_usual":"BF","blender_bottle_item_mob":"CF","addbutton":"EF","blender_bottle_title_mob":"FF","blender_bottle_bold_mob":"GF","blender_bottle_usual_mob":"HF","bolder":"IF","bottom_margin_4":"JF","bottom_margin_16":"KF"};
    if(module.hot) {
      // 1738836196939
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  